module.exports = __webpack_public_path__ + "img/scc-03.391eda8f.png";